export function usePopups() {
    function setPopup(type, display) {
        if (type) {
            const el = document.getElementById(type);
            if (el) el.style.display = display;
        }
    }

    return { setPopup };
}
